import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import React from 'react';
import { TypeOcrH6 } from './Types';

interface SectionHeaderProps {
  title: string;
  buttonText?: string;
  href?: string;
}
export default function SectionHeader(props: SectionHeaderProps) {
  if (props.href) {
    return (
      <>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          ml={3}
          mr={3}
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <TypeOcrH6 sx={{ textAlign: { xs: 'center', md: 'left' } }} noWrap>
            {props.title}
          </TypeOcrH6>
          <Divider
            sx={{
              alignItems: 'center',
              width: { xs: '100%', md: '45%' },
              height: '0.5px',
            }}
            color='black'
            variant='middle'
          />
          <Button
            variant='outlined'
            sx={{
              borderRadius: '0',
              borderColor: 'info.main',
              color: 'info.main',
              mb: 2,
              mt: 2,
            }}
            size='medium'
            href={props.href}
          >
            {props.buttonText}
          </Button>
        </Stack>
      </>
    );
  } else {
    return (
      <Box ml={3} mr={3}>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          justifyContent='center'
          alignItems='center'
        >
          <TypeOcrH6>{props.title}</TypeOcrH6>
          <Box display={{ xs: 'none', md: 'block' }} width='100%'>
            <Divider
              color='black'
              aria-hidden='true'
              variant='inset'
              style={{ height: '0.5px', width: '80%' }}
            ></Divider>
          </Box>
        </Stack>
      </Box>
    );
  }
}
